module.exports = __webpack_public_path__ + "img/he10.6b334e5f.png";